import React, { Component, Fragment } from "react";

import { MODAL_TYPES } from "../../constants/modals";
import SecuritySigninForm from "../../containers/SecuritySigninForm";

class SecuritySigninModal extends Component {
  constructor(props) {
    super(props);

    this.handleSignup = this.handleSignup.bind(this);
  }

  handleSignup() {
    this.props.openModal({ modalType: MODAL_TYPES.SIGNUP });
  }

  render() {
    return (
      <Fragment>
        <div className="modal__header">
          <span>Connexion</span>
        </div>

        <div className="modal__body">
          <div className="modal__close" onClick={this.props.handleCloseModal}>
            <svg className="bars-icon" viewBox="0 0 24 24">
              <path d="M1,1 L22,22 M1,22 L22,1" stroke="#000" strokeWidth="1" />
            </svg>
          </div>

          <div className="signin-modal">
            <div className="signin-modal__description">
              Par mesure de sécurité, vous devez vous reconnecter afin de
              <span className="font-bold"> modifier </span>
              vos informations.
            </div>
            <div className="signin-modal__content">
              <div className="signin-modal__left">
                <SecuritySigninForm />
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default SecuritySigninModal;



// WEBPACK FOOTER //
// ./src/components/modals/SecuritySigninModal.js